import { findIndex } from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const USERS_LOADED = 'USERS_LOADED';

const data = {
  users: [],
  ucceAgents: [],
  fetching: false,
  ucceAgentsFetching: false,
  usersTotal: 0,
  ucceAgentsTotal: [],
  currentUser: {},
  activMenuItem: -1,
  pageSizeDefault: undefined,
  ucceAgentsPageSizeDefault: undefined,
};

const actions = {
  loadUsers({ commit }, {
    page, pageSize, moreData = false, pageSizeNotSave = false,
  }) {
    commit('USERS_FETCHING');
    return api.getUsers({ page, pageSize }).then((res) => {
      commit(USERS_LOADED, {
        list: res.users,
        /* eslint-disable no-underscore-dangle */
        total: res._totalCount,
        /* eslint-enable no-underscore-dangle */
        pageSize: pageSizeNotSave ? undefined : res.pageSize,
        moreData,
      });
      return res;
    }).catch((err) => {
      commit('STOP_USERS_FETCHING');
      throw err;
    });
  },
  loadUcceAgents({ commit }, {
    startIndex, pageSize, moreData = false, search = null,
  }) {
    commit('UCCE_AGENTS_FETCHING');
    return api.getUcceAgents({ startIndex, pageSize, search }).then((res) => {
      commit('UCCE_AGENTS_LOADED', {
        ucceAgents: res.agents,
        total: res.totalCount,
        pageSizeDefault: res.pageSize,
        moreData,
      });
      return res;
    }).catch((err) => {
      commit('STOP_UCCE_AGENTS_FETCHING');
      throw err;
    });
  },
  async getUser({ commit }, { id }) {
    const user = await api.getUserById({ id });
    commit('SET_CURRENT_USER', user);
    return user;
  },
  createUser({ commit, state }, userParams) {
    const users = JSON.parse(JSON.stringify(state.users));
    return api.createUser(userParams).then((user) => {
      users.push(user);
      commit(USERS_LOADED, {
        list: users,
      });
      return user;
    });
  },
  async updateUser({ commit, state }, userParams) {
    const result = await api.updateUser(userParams);
    const users = JSON.parse(JSON.stringify(state.users));
    const index = findIndex(users, { id: userParams.id });
    users[index] = { ...users[index], ...JSON.parse(JSON.stringify(userParams)) };
    commit(USERS_LOADED, {
      list: users,
    });
    return result;
  },
  async deleteUser({ commit, state }, id) {
    const result = await api.deleteUser({ id });
    const users = state.users.filter((user) => user.id !== id);
    commit(USERS_LOADED, {
      list: users,
      total: state.usersTotal - 1,
    });
    return result;
  },
  updatePassword(_, { id, password }) {
    return api.updateUserPassword({ id, password }).then((res) => res);
  },
  setActivMenuItem({ commit }, value) {
    commit('SET_ACTIV_MENU_ITEM', value);
  },
};

const mutations = {
  USERS_LOADED(state, {
    list, total, moreData, pageSize,
  }) {
    if (moreData) {
      state.users = state.users.concat(list);
    } else {
      state.users = list;
    }
    state.pageSizeDefault = pageSize || state.pageSizeDefault;
    state.usersTotal = total || state.usersTotal;
    mutations.STOP_USERS_FETCHING(state);
  },
  UCCE_AGENTS_LOADED(state, {
    ucceAgents, total, moreData, pageSizeDefault,
  }) {
    if (moreData) {
      state.ucceAgents = state.ucceAgents.concat(ucceAgents);
    } else {
      state.ucceAgents = ucceAgents;
    }
    state.ucceAgentsPageSizeDefault = pageSizeDefault || state.ucceAgentsPageSizeDefault;
    state.ucceAgentsTotal = total || state.ucceAgentsTotal;
    mutations.STOP_UCCE_AGENTS_FETCHING(state);
  },
  USERS_FETCHING(state) {
    state.fetching = true;
  },
  STOP_USERS_FETCHING(state) {
    state.fetching = false;
  },
  UCCE_AGENTS_FETCHING(state) {
    state.ucceAgentsFetching = true;
  },
  STOP_UCCE_AGENTS_FETCHING(state) {
    state.ucceAgentsFetching = false;
  },
  SET_CURRENT_USER(state, value) {
    state.currentUser = value;
  },
  SET_ACTIV_MENU_ITEM(state, value) {
    if (state.activMenuItem === value) {
      state.activMenuItem = -1;
    } else {
      state.activMenuItem = value;
    }
  },
};

const store = {
  state: data,
  actions,
  mutations,
  namespaced: true,
};

export default store;
